
import _ from 'lodash';
import axios from 'axios';
// eslint-disable-next-line
import moment from "moment";

import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { UserContext } from '.';


export default class UserProvider extends Component {

  state = {
    isAuthenticated: false,
    isInitialized: false,
    isSuperuser: false,
    permissions: [],
    data: {},
    errorMessage: undefined,
    showSnackbarError: false
  };

  logIn = (username, password) => {
    const data = {
      username: username,
      password: password
    };
    return axios.post('account/login', data).then(res => {
      this.setState({
        isAuthenticated: true,
        data: res.data,
        isSuperuser: res.data.is_superuser,
        permissions: res.data.permissions
      });

      return true;
    }).catch((e) => {
      const response = e.response;

      let message = 'Unknown error';
      if (response) {
        message = response.data.detail;
      }
      else if (e.message) {
        message = e.message;
      }

      this.setState({
        errorMessage: message,
        showSnackbarError: true
      });

      return false;
    });
  };

  logOut = () => {
    axios.delete('account').then(res => {
      this.setState({
        isAuthenticated: false,
        isSuperuser: false,
        permissions: [],
        data: {}
      });
    });
  };

  hasPerm = (name) => {
    const { isSuperuser, permissions } = this.state;
    return isSuperuser || permissions.indexOf(name) !== -1;
  };

  showToaster = (message) => {
  };

  init = () => {
    axios.get('account')
      .then(res => {
        this.setState({
          isAuthenticated: true,
          isInitialized: true,
          data: res.data,
          isSuperuser: res.data.is_superuser,
          permissions: res.data.permissions
        });

        this.changeDefaultTimezone(res.data.department_active.timezone);
      })
      .catch((e) => {
        this.setState({
          isInitialized: true
        });
      });
  };

  mergeData = (data) => {
    let userData = _.merge(this.state.data, data);
    this.setState({
      data: userData
    })
  };

  componentDidMount() {
    this.init();
  }

  snackbarErrorClose = () => {
    this.setState({
      showSnackbarError: false
    })
  };

  changeDefaultTimezone = (timezone) => {
  }

  patch = (data, callback) => {
    axios.patch('account', data)
      .then(res => {
        this.setState({
          data: res.data
        });
        this.changeDefaultTimezone(res.data.department_active.timezone);
        if (typeof callback === 'function') {
          callback(res.data);
        }
      })
  }

  render() {
    const { errorMessage, showSnackbarError } = this.state;
    return (
      <UserContext.Provider value={{
        state: this.state,
        data: this.state.data,
        mergeData: this.mergeData,
        showToaster: this.showToaster,
        actions: {
          logIn: this.logIn,
          logOut: this.logOut,
          hasPerm: this.hasPerm,
          init: this.init,
          patch: this.patch
        }
      }}>
        <Snackbar
          open={showSnackbarError}
          autoHideDuration={4000}
          onClose={() => this.snackbarErrorClose()}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          <MuiAlert elevation={6} variant="filled" onClose={() => this.snackbarErrorClose()} severity="error">
            {errorMessage}
          </MuiAlert>
        </Snackbar>

        {this.props.children}
      </UserContext.Provider>
    );
  }
}
